import "./intro.scss";
import { init } from "ityped";
import { useEffect, useRef } from "react";
import img1 from './Sandeep.png';
import {faFacebookSquare} from '@fortawesome/free-brands-svg-icons';
import {faGithubSquare} from '@fortawesome/free-brands-svg-icons';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["React JS", "Javascript", "HTML", "CSS/SASS", "Bootstrap", "SQL", "MySQL"],
    });
  }, []);

  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgContainer">
          <img src={img1} alt="profile pic" />
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hi There, I'm</h2>
          <h1>Sandeep <span>Bisht </span> </h1>
          <h3>
            Front End Developer -  <span ref={textRef}></span>
          </h3>
          <div className="icons">
                    <a href="https://www.facebook.com/sandeepbisht53/" rel="noreferrer" target="_blank" className="icon-holder">
                        <FontAwesomeIcon icon={faFacebookSquare} className="icon fb" />
                    </a>
                    <a href="https://github.com/Sandeepbishtt" rel="noreferrer" target="_blank" className="icon-holder">
                        <FontAwesomeIcon icon={faGithubSquare} className="icon gh" />
                    </a>
                    <a href="https://www.linkedin.com/in/sandeep-bisht-a0ab8820b/" rel="noreferrer" target="_blank" className="icon-holder">
                        <FontAwesomeIcon icon={faLinkedin} className="icon yt"/>
                    </a>
                </div>
        </div>
       </div>
    </div>
  );
}
